import { render } from "./Application.vue?vue&type=template&id=4ca2bb67"
import script from "./Application.vue?vue&type=script&lang=js"
export * from "./Application.vue?vue&type=script&lang=js"

import "./Application.vue?vue&type=style&index=0&id=4ca2bb67&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__